import React, { useState, useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Link, useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { get } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Form } from 'react-bootstrap';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import moment from 'moment';

const CouponsView = () => {
  let { id } = useParams();
  const [couponDetails, setCouponDetails] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [redeemStatus, setReedemStatus] = useState('');
  const clickToDownload = useRef(null);

  const getCouponTrackerDetail = () => {
    try {
      get(`/cs/coupons-trackers/coupons-details/?id=${id}&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&isRedeem=${redeemStatus}`).then(
        (response) => {
          setCouponDetails(response?.data?.rows);
          setTotalRecords(response?.data?.count);
        }
      );
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  const excelReport = () => {
    try {
      get(`/cs/coupons-trackers/coupons-details/?id=${id}&conditionType=download&isRedeem=${redeemStatus}`).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getCouponTrackerDetail();
      }
    },
    [redeemStatus],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getCouponTrackerDetail();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/cs/coupons"> Coupons Tracker</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/cs/coupons/${id}`}>Coupon Tracker Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Coupons | {totalRecords ?? 0}
          </h4>
          <div className="d-flex align-items-center">
            <Form.Select
              value={redeemStatus}
              onChange={(e) => setReedemStatus(e.target.value)}
              style={{ width: '200px' }}
              className="input me-3"
            >
              <option value="">Redeemed Status</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </Form.Select>
            <GrDocumentExcel
              title="Download excel"
              style={{ cursor: 'pointer', width: '25px', height: '25px' }}
              className="react-icons green"
              onClick={excelReport}
            />
            <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Company Name</th>
                    <th>Coupon Code</th>
                    <th>Coupon Value</th>
                    <th>Location</th>
                    <th>Customer</th>
                    <th>Customer Mobile</th>
                    <th>Redeemed?</th>
                    <th>Valid From</th>
                    <th>Valid Till</th>
                    <th>Used On</th>
                  </tr>
                </thead>
                <tbody>
                  {couponDetails.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item['Company.name'] ?? '-'}</td>
                        <td>{item?.couponCode}</td>
                        <td>₹ {item?.couponValue}</td>
                        <td>{item?.User?.Branch?.name ?? '-'}</td>
                        <td>{item['Customer.name'] ?? '-'}</td>
                        <td>{item['Customer.mobile'] ?? '-'}</td>
                        <td>{item?.usedOn ? 'Yes' : 'No'}</td>
                        <td>{moment(item?.validFrom).format('DD/MM/YY')}</td>
                        <td>{moment(item?.validTill).format('DD/MM/YY')}</td>
                        <td>{item?.usedOn ? moment(item.usedOn).format('DD/MM/YY hh:mm A') : '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CouponsView;
